module.exports = __webpack_public_path__ + "img/iAMP_Hydro_horizontal.4e41bd18.jpg";